import React from 'react'

import Button from 'app/components/ButtonDefault'
import Back from 'app/components/SVGS/Back'
import { IWrapperStepProps } from './interface'

import './styles.scss'
const bc = 'wrapper-step'

const WrapperStep: React.FC<IWrapperStepProps> = ({
  nextStep,
  children,
  customAction,
  btnText = 'Next',
  disabled = false,
  title,
  subtitle,
  withButton = true,
  previousStep,
  currentStep,
  invalid,
  isShowBackReturnButton = true,
  ...props
}) => {
  const isShowBackButton = currentStep !== 1 && isShowBackReturnButton
  return (
    <div className={`${bc}__wrapper`}>
      {isShowBackButton && (
        <div
          style={{ cursor: 'pointer', position: 'relative', left: '-72px', top: '24px' }}
          onClick={() => previousStep && previousStep()}
        >
          <Back /> Back
        </div>
      )}
      {title && <h2 className={`${bc}__title`}>{title}</h2>}
      {subtitle && <h3 className={`${bc}__subtitle`}>{subtitle}</h3>}
      {React.isValidElement(children)
        ? React.cloneElement(children, {
            nextStep,
            currentStep,
            labelClass: `${bc}__title`,
            ...props,
          })
        : children}
      {withButton && (
        <Button
          type="button"
          tabIndex={-1}
          primary
          onClick={() => {
            nextStep && nextStep()
            customAction && customAction()
          }}
          disabled={disabled}
        >
          {btnText}
        </Button>
      )}
    </div>
  )
}

export default WrapperStep
